module.exports = {
	"0": "0x4E73b858fD5D7A5fc1c3455061dE52a53F35d966",
	"1": "0x9CB391dbcD447E645D6Cb55dE6ca23164130D008",
	"2": "0x5732B2F88cbd19B6f01E3a96e9f0D90B917281E5",
	"3": "0x4dF32584890A0026e56f7535d0f2C6486753624f",
	"4": "0x0b6F6CE4BCfB70525A31454292017F640C10c768",
	"5": "0x63bE8347A617476CA461649897238A31835a32CE",
	"6": "0x9451961b7Aea1Df57bc20CC68D72f662241b5493",
	"7": "0x22699e6AdD7159C3C385bf4d7e1C647ddB3a99ea",
	"8": "0xf94b476063B6379A3c8b6C836efB8B3e10eDe188",
	"9": "0x5cECE66f3EB19f7Df3192Ae37C27D96D8396433D",
	"10": "0x848fb2124071146990c7abE8511f851C7f527aF4",
	"11": "0xaB4F3F2644060b2D960b0d88F0a42d1D27484687",
	"12": "0x11343d543778213221516D004ED82C45C3c8788B",
	"13": "0x9b261b23cE149422DE75907C6ac0C30cEc4e652A",
	"14": "0xdCeA38B2ce1768E1F409B6C65344E81F16bEc38d",
	"15": "0x096bb5e93a204BfD701502EB6EF266a950217218",
	"16": "0x97E982a15FbB1C28F6B8ee971BEc15C78b3d263F",
	"18": "0x8d07AC34D8f73e2892496c15223297e5B22B3ABE",
	"19": "0x200d3d9Ac7bFd556057224e7aEB4161fED5608D0",
	"20": "0xda5b3Fb76C78b6EdEE6BE8F11a1c31EcfB02b272",
	"21": "0xcE1BB92eeb71AF5Fec09D38B0c854d55285f6e04",
	"22": "0xBE732789f2963E0522719F2D3fB55E6bfe07e92e",
	"ethernaut": "0xD991431D8b033ddCb84dAD257f4821E9d5b38C33"
};


//////////////////
// WEBPACK FOOTER
// ./gamedata/deploy.rinkeby.json
// module id = 1522
// module chunks = 0